<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      screenWidth: document.body.clientWidth,
      nowUrl: ''
    }
  },
  name: 'App',
  watch: {
    $route (to, from) {
      /* this.nowUrl = to.path
      console.log('当前：' + this.nowUrl)
      console.log('to：' + to.path)
      console.log('from：' + from.path) */
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        this.$router.go(0)
        // console.log(this.screenWidth)
      })()
    }
  }
}
</script>

<style>
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue